export const toUnixSecondsParam = (date: Date | undefined) => {
  if (!date || !Number.isFinite(date.getTime())) {
    return undefined;
  }
  return String(Math.floor(date.getTime() / 1000));
};
